module.exports = {"371323001":"沂城街道","371323002":"龙家圈街道","371323101":"马站镇","371323102":"高桥镇","371323103":"许家湖镇","371323104":"黄山铺镇","371323106":"诸葛镇","371323107":"崔家峪镇","371323108":"四十里堡镇","371323109":"杨庄镇","371323110":"夏蔚镇","371323111":"沙沟镇","371323112":"高庄镇","371323113":"院东头镇","371323115":"富官庄镇","371323116":"道托镇","371323117":"泉庄镇","371323201":"圈里乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371323.json
// module id = 1462
// module chunks = 0